<!--
 * @Author: chenyourong
 * @Date: 2025-05-08 18:06:50
 * @LastEditors: chenyourong
 * @LastEditTime: 2025-06-11 17:56:25
 * @Description: 
 * @FilePath: /vue-admin-template-master/src/views/channel/channelList/index.vue
-->
<template>
  <div class="channel-list">
    <Search v-bind="filterAttrs" v-on="filterEvent"></Search>
    <Table
      :list-query-params.sync="listQueryParams"
      v-bind="tableAttrs"
      v-on="tableEvent"
    />
    <el-dialog
      :title="title"
      v-if="dialogFormVisible"
      :visible.sync="dialogFormVisible"
      width="572px"
      top="3vh"
    >
      <Detail
        ref="getTable"
        :title="title"
        :styleType="styleType"
        :tableData="dialogForm"
        :tableFormAttrs="dialogFormAttrs"
        formLabelWidth="92px"
        @resetSecret="resetSecret"
        :isEdit="title === '编辑渠道'"
        @handleAvatarSuccess="handleAvatarSuccess"
      >
      </Detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm()">{{
          buttonName
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Table from "@/components/Table/index.vue";
import Detail from "@/components/Detail/index.vue";
import Search from "@/components/Search/index.vue";
import md5 from "js-md5";
import XLSX from "xlsx";
import { getPathName } from "@/utils/index.js";

import {
  createChannel,
  channelList,
  updateChannel,
  channelSecretReset,
  channelDetail,
} from "@/api/channel.js";
import Cookie from 'js-cookie';
import { PASSWORD_PLACEHOLDER } from "@/utils/validate";

const DefaultTableQuery = {
  pageNum: 1,
  pageSize: 10,
};
const CHANNEL_LIST_STATE_KEY = "channel_list_query_state";
const EXPORT_PAGE_SIZE = 1000;
const EXPORT_REQUEST_TIMEOUT = 120000;

export default {
  name: "businessList",
  components: {
    Table,
    Detail,
    Search,
  },
  data() {
    return {
      title: "添加渠道",
      buttonName: "添加",
      styleType: "dialog",
      // 参数
      listQueryParams: { ...DefaultTableQuery },
      tableData: [],
      tableConfig: [
        {
          label: "渠道信息",
          minWidth: "140",
          floorWidth: "120",
          maxWidth: "360",
          autoWidth: true,
          value: "channelName",
          subValue: "channelDesc",
          format: "stack",
          fixed: "left",
        },
        {
          label: "渠道ID",
          width: "80",
          value: "channelId",
        },
        {
          label: "预存款总金额",
          width: "105",
          value: "rechargeTotalAmount",
        },
        {
          label: "预存款余额",
          width: "105",
          value: "predepositAmount",
          headerTooltip: "包含锁定预存款",
        },
        {
          label: "可用预存款",
          width: "95",
          value: "availablePredeposit",
        },
        {
          label: "已使用金额",
          width: "105",
          value: "usedPredeposit",
          headerTooltip: "已核销的金额",
        },
        {
          label: "锁定预存款",
          width: "95",
          value: "lockedPredeposit",
        },
        {
          label: "联系人",
          width: "70",
          value: "contact",
        },
        {
          label: "手机号",
          width: "90",
          value: "phone",
        },
        {
          label: "状态",
          width: "80",
          format: "status",
          value: "status",
        },
      ],
      dialogFormAttrs: [
        {
          title: "渠道名称:",
          placeholder: "请输入渠道名称",
          type: "input",
          value: "channelName",
          required: true,
        },
        {
          title: "渠道描述:",
          placeholder: "请输入渠道描述",
          type: "textarea",
          value: "channelDesc",
        },
        {
          title: "渠道ID:",
          placeholder: "系统自动生成",
          type: "input",
          inputType: "number",
          value: "channelId",
          disabled: true,
        },
        {
          title: "App ID:",
          placeholder: "系统自动生成",
          type: "input",
          value: "appId",
          disabled: true,
        },
        {
          title: "App Secret:",
          placeholder: "系统自动生成",
          type: "input",
          value: "appSecret",
          icon: "el-icon-refresh-right",
          disabled: true,
        },
        {
          title: "IP白名单:",
          placeholder: "请输入IP白名单,多个ip用英文逗号分隔",
          type: "textarea",
          value: "ipWhiteList",
          required: true,
        },
        {
          title: "回调地址:",
          placeholder: "请输入回调地址",
          type: "input",
          value: "callbackUrl",
        },
        {
          title: "联系人:",
          placeholder: "请输入联系人",
          type: "input",
          value: "contact",
          required: true,
        },
        {
          title: "手机号:",
          placeholder: "请输入手机号",
          type: "input",
          value: "phone",
          inputType: "number",
          required: true,
        },
        {
          title: "邮箱:",
          placeholder: "请输入邮箱",
          type: "input",
          value: "email",
          required: true,
        },
        {
          title: "状态:",
          placeholder: "请输入邮箱",
          type: "radio",
          value: "status",
        },
        {
          title: "初始密码:",
          placeholder: PASSWORD_PLACEHOLDER,
          type: "input",
          inputType: "text",
          value: "passwd",
          isClosePwd: true,
        },
      ],
      // 表格加载loading
      loadingStatus: false,
      buttonsName: [
        {
          label: "查看",
          route: "channelId",
        },
        {
          label: "编辑",
        },
      ],
      optionWidth: 148,
      dialogFormVisible: false,
      dialogForm: {
        channelName: "",
        channelDesc: "",
        merchantLogo: "",
        predepositAmount: "",
        contact: "",
        status: "",
        passwd: "",
      },
      // url参数
      params: {
        pageSize: 10,
        pageNum: 0,
        searchKey: "",
        searchVal: "",
      },
      filterButtonText: [
        {
          label: "添加渠道",
          type: "primary",
        },
        {
          label: "导出Excel",
          type: "primary",
        },
      ],
      filterOptions: [
        {
          type: "multiSelect",
          placeholder: "请选择",
          selectValue: "channelName",
          inputValue: "",
          isSearch: false,
          inputWidth: "264px",
          selectWidth: "105px",
          options: [
            {
              label: "渠道名称",
              width: "120",
              value: "channelName",
            },
            {
              label: "渠道ID",
              width: "120",
              value: "channelId",
            },
            {
              label: "手机号",
              width: "120",
              value: "phone",
            },
          ],
        },
        {
          type: "button",
        },
      ],
      multipleSelection: [],
      type: +Cookie.get('type')
    };
  },
  computed: {
    // 表格属性
    tableAttrs() {
      const keyword =
        this.params.searchKey === "channelName"
          ? (this.params.searchVal || "").trim()
          : "";
      const config = this.tableConfig.map((item) => {
        if (item.value !== "channelName") return item;
        return {
          ...item,
          highlightKeyword: keyword,
        };
      });
      return {
        // 表头配置
        config,
        // 表格数据
        tableData: this.tableData,
        // loading
        loadingStatus: this.loadingStatus,
        // 按钮名称
        buttonsName: this.buttonsName,
        // 操作栏宽度
        optionColumnWidth: this.optionWidth,
        isSelection: true,
        isShowNumber: true,
      };
    },
    // 表格事件
    tableEvent() {
      return {
        // 按钮操作
        subOpitonButton: this.handleTableOption,
        // 分页
        subClickPagination: this.handleRefreshList,
        // 表格数据选择
        subSelected: this.handleSelectionChange,
      };
    },
    filterAttrs() {
      return {
        // 按钮名称
        filterButtonText: this.filterButtonText,
        filterOptions: this.filterOptions,
      };
    },
    filterEvent() {
      return {
        // 选择数据回调
        handleFilter: this.handleFilter,
        handleFilterButton: this.handleFilterButton,
        clickSearch: this.clickSearch,
      };
    },
  },
  beforeRouteLeave(to, from, next) {
    this.saveListState();
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const fromChannelDetail = /^\/channel\/channelList\/.+/.test(from.path);
      if (fromChannelDetail) {
        vm.restoreListState();
      } else {
        sessionStorage.removeItem(CHANNEL_LIST_STATE_KEY);
      }
      vm.init();
      vm.getList();
    });
  },
  methods: {
    saveListState() {
      sessionStorage.setItem(
        CHANNEL_LIST_STATE_KEY,
        JSON.stringify({
          listQueryParams: { ...this.listQueryParams },
          params: { ...this.params },
        })
      );
    },
    restoreListState() {
      const cached = sessionStorage.getItem(CHANNEL_LIST_STATE_KEY);
      if (!cached) return;
      try {
        const state = JSON.parse(cached);
        if (state.listQueryParams) {
          this.listQueryParams = {
            ...this.listQueryParams,
            ...state.listQueryParams,
          };
        }
        if (state.params) {
          this.params = {
            ...this.params,
            ...state.params,
          };
        }
        const searchFilter = this.filterOptions.find(
          (item) => item.type === "multiSelect" && !item.noShowInput
        );
        if (searchFilter) {
          if (this.params.searchKey) {
            searchFilter.selectValue = this.params.searchKey;
          }
          searchFilter.inputValue = this.params.searchVal || "";
        }
      } catch (error) {
        sessionStorage.removeItem(CHANNEL_LIST_STATE_KEY);
      }
    },
    init() {
      if (this.type === 2) {
        this.filterButtonText = [
          {
            label: "导出Excel",
            type: "primary",
          },
        ];
        this.buttonsName = [
          {
            label: "查看",
            route: "channelId",
          },
        ];
      }
    },
    // 获取列表
    async getList(channelId) {
      try {
        // 表格加载loading
        this.loadingStatus = true;
        // 分页数据作为参数给服务端
        this.params.pageSize = this.listQueryParams.pageSize;
        this.params.pageNum = this.listQueryParams.pageNum - 1;
        // 发送请求,请求到的数据格式见下文，
        const { data } = await channelList(this.params);
        if (data.list) {
          data.list.forEach((item) => {
            if (item.channelId === channelId) {
              this.dialogForm.appSecret = item.appSecret;
            }
            item.rechargeTotalAmount = item.rechargeTotalAmount ? item.rechargeTotalAmount / 100 : 0;
            item.availablePredeposit = item.availablePredeposit ? item.availablePredeposit / 100 : 0;
            item.lockedPredeposit = item.lockedPredeposit ? item.lockedPredeposit / 100 : 0;
            item.predepositAmount = item.predepositAmount ? item.predepositAmount / 100 : 0;
            item.usedPredeposit =
              Math.round(
                ((item.rechargeTotalAmount || 0) - (item.predepositAmount || 0)) * 100
              ) / 100;
            item.status = item.status ? item.status.toString() : "0";
          });
        }
        this.listQueryParams.total = data.total;
        // 数据给表格
        this.tableData = data.list || [];
        this.loadingStatus = false;
      } catch (error) {
        console.log(error);
      }
    },
    // 点击上传
    handleAvatarSuccess(file) {
      console.log("🚀 ~ handleAvatarSuccess ~ file:", file);
      this.dialogForm.merchantLogo = URL.createObjectURL(file.raw);
    },
    resetSecret() {
      this.$confirm("确认重置App Secret?", "", {
        type: "warning",
        confirmButtonText: "是",
        cancelButtonText: "否",
      })
        .then((res) => {
          channelSecretReset({
            channelId: this.dialogForm.channelId,
          }).then((res) => {
            this.getList(this.dialogForm.channelId);
            this.$message.success("重置App Secret成功");
          });
        })
        .catch(() => {
          this.$message.info(`已取消重置App Secret`);
        });
    },
    // 弹窗点击添加按钮
    submitForm() {
      this.$refs.getTable.getTableRef().validate((valid) => {
        if (valid) {
          const params = {
            ...this.dialogForm,
            status: Number(this.dialogForm.status),
            callbackUrl: (this.dialogForm.callbackUrl || "").trim(),
          };
          if (this.title === "添加渠道") {
            params.passwd = md5(md5(this.dialogForm.passwd));
            createChannel(params).then((res) => {
              this.getList();
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.dialogFormVisible = false;
            });
          }
          if (this.title === "编辑渠道") {
            if (this.dialogForm.passwd) {
              params.passwd = md5(md5(this.dialogForm.passwd));
            } else {
              delete params.passwd;
            }
            updateChannel(params).then((res) => {
              this.getList();
              this.$message({
                message: "修改成功",
                type: "success",
              });
            });
            this.dialogFormVisible = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除渠道
    deleteShopDialog() {
      this.$confirm("确定删除吗?", "", {
        type: "warning",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async () => {
          this.$message.success(" 删除成功");
        })
        .catch(() => {
          this.$message.info(" 已取消删除");
        });
    },
    handleFilter(val) {
      console.log(
        "🔍 ~ handleFilter ~ src/views/channel/channelList/index.vue:411 ~ val:",
        val
      );
      this.params.searchKey = val.selectValue;
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 点击编辑
    handleTableOption(index, row, option) {
      this.operationalData = { ...row };
      if (option.label === "查看") {
        console.log(index, row, option);
      } else if (option.label === "编辑") {
        var row = JSON.parse(JSON.stringify(row));
        this.dialogFormVisible = true;
        this.title = "编辑渠道";
        this.buttonName = "确定";
        this.dialogForm = row;
        this.dialogForm.status = row.status.toString();
        // 列表接口 callbackUrl 可能 omitempty 缺失，需 $set 保证可输入/粘贴
        this.$set(this.dialogForm, "callbackUrl", (row.callbackUrl || "").trim());
        channelDetail({ channelId: row.channelId }).then(({ data }) => {
          this.$set(
            this.dialogForm,
            "callbackUrl",
            (data.callbackUrl || "").trim()
          );
        });
        this.dialogFormAttrs.forEach((val) => {
          if (val.isClosePwd) {
            val.title = "重置密码:";
          }
          if (val.value === "appSecret") {
            val.icon = "el-icon-refresh-right";
          }
        });
      } else if (option === "删除") {
        console.log(index, row, option);
      }
    },
    // 分页操作
    handleRefreshList() {
      this.getList();
    },
    clickSearch(val) {
      this.params.searchKey = val.selectValue;
      this.params.searchVal = (val.inputValue || "").trim();
      this.listQueryParams.pageNum = 1; // 重置页码
      this.getList();
    },
    normalizeChannelExportItem(item) {
      item.rechargeTotalAmount = item.rechargeTotalAmount
        ? item.rechargeTotalAmount / 100
        : 0;
      item.availablePredeposit = item.availablePredeposit
        ? item.availablePredeposit / 100
        : 0;
      item.lockedPredeposit = item.lockedPredeposit
        ? item.lockedPredeposit / 100
        : 0;
      item.predepositAmount = item.predepositAmount
        ? item.predepositAmount / 100
        : 0;
      item.usedPredeposit =
        Math.round(
          ((item.rechargeTotalAmount || 0) - (item.predepositAmount || 0)) * 100
        ) / 100;
      item.status = item.status ? item.status.toString() : "0";
    },
    channelStatusText(status) {
      return String(status) === "0" ? "启用" : "暂停";
    },
    async fetchAllChannelsForExport() {
      const allList = [];
      let pageNum = 0;
      let total = 0;

      while (true) {
        const { data } = await channelList(
          {
            ...this.params,
            pageSize: EXPORT_PAGE_SIZE,
            pageNum,
          },
          { timeout: EXPORT_REQUEST_TIMEOUT }
        );
        if (pageNum === 0) {
          total = data.total || 0;
        }
        const list = data.list || [];
        if (!list.length) {
          break;
        }
        list.forEach((item) => this.normalizeChannelExportItem(item));
        allList.push(...list);
        pageNum += 1;
        if (list.length < EXPORT_PAGE_SIZE) {
          break;
        }
        if (total > 0 && allList.length >= total) {
          break;
        }
      }

      return allList;
    },
    async exportExcel() {
      const headers = [
        "渠道名称",
        "渠道描述",
        "渠道ID",
        "预存款总金额",
        "预存款余额",
        "可用预存款",
        "已使用金额",
        "锁定预存款",
        "联系人",
        "手机号",
        "状态",
      ];
      const keys = [
        "channelName",
        "channelDesc",
        "channelId",
        "rechargeTotalAmount",
        "predepositAmount",
        "availablePredeposit",
        "usedPredeposit",
        "lockedPredeposit",
        "contact",
        "phone",
        "status",
      ];
      const loading = this.$loading({
        lock: true,
        text: "正在导出，请稍候...",
      });
      try {
        let arr = [];
        if (this.multipleSelection.length) {
          arr = this.multipleSelection;
        } else {
          arr = await this.fetchAllChannelsForExport();
        }
        if (!arr.length) {
          this.$message.warning("暂无数据可导出");
          return;
        }
        const exportData = arr.map((item) =>
          keys.map((key) => {
            if (key === "status") {
              return this.channelStatusText(item.status);
            }
            return item[key];
          })
        );
        exportData.unshift(headers);
        const ws = XLSX.utils.aoa_to_sheet(exportData);
        ws["!cols"] = [
          { wch: 20 },
          { wch: 24 },
          { wch: 12 },
          { wch: 14 },
          { wch: 14 },
          { wch: 14 },
          { wch: 14 },
          { wch: 14 },
          { wch: 12 },
          { wch: 14 },
          { wch: 10 },
        ];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, `渠道列表${getPathName()}.xlsx`);
      } catch (error) {
        console.log(error);
        this.$message.error("导出失败，请稍后重试");
      } finally {
        loading.close();
      }
    },
    // 点击添加渠道弹窗
    handleFilterButton(val) {
      if (val === "导出Excel") {
        this.exportExcel();
        return;
      }
      if (val === "添加渠道") {
        this.dialogFormVisible = true;
        this.title = "添加渠道";
        this.buttonName = "添加";
        this.dialogForm = {};
        this.$set(this.dialogForm, "callbackUrl", "");
        // this.dialogForm.email = "140@qq.co"; // 测试，后面去掉
        // this.dialogForm.phone = "19412345671";
        this.dialogFormAttrs.forEach((val) => {
          if (val.isClosePwd) {
            val.title = "初始密码:";
          }
          if (val.value === "appSecret") {
            val.icon = "";
          }
        });
      }
      if (val === "删除渠道") {
        this.$confirm("确定删除吗?", "", {
          type: "warning",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(async () => {
            this.$message.success(" 删除成功");
          })
          .catch(() => {
            this.$message.info(" 已取消删除");
          });
      }
    },
  },
};
</script>
<style lang="scss">
.channel-list {
  .el-dialog__wrapper {
    display:inherit;
  }
  .filter-container {
    .el-input {
      width: 265px;
      input {
        height: 32px;
      }
      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }
    .el-select {
      margin-right: 4px;
      .el-input {
        width: 106px;
      }
    }
    .el-input-group__append {
      background: #fff;
    }
    .el-button {
      padding: 12px;
    }
    .filter-container__right {
      .el-button {
        width: 88px;
        height: 32px;
        line-height: 32px;
        padding: 0;
        font-size: 14px;
      }
      .el-button--primary {
        background: #1890ff;
      }
      .el-button--info {
        background: #f5f5f5;
        color: rgba(0, 0, 0, 0.25);
      }
    }
  }
  .deleteShopDialog {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      display: flex;
      align-items: center;
      border: none;
    }
    .el-icon-warning-outline {
      font-size: 22px;
      color: #faad14;
      margin-right: 16px;
    }
    .el-dialog__footer {
      padding: 0px 20px 20px;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
.shop-list {
  .filter-container {
    @include flex;
    justify-content: space-between;
    padding: 0 24px;
    width: 100%;
    height: 80px;
    background: #fff;
  }
  .show-pwd {
    position: absolute;
    right: 60px;
    top: 0;
    font-size: 16px;
    color: #000;
    cursor: pointer;
    user-select: none;
  }
  .char-count {
    text-align: right;
    color: #666;
    font-size: 12px;
    margin-top: 4px;
  }

  .limit-reached {
    color: #f56c6c;
    font-weight: bold;
  }
}
</style>
